import { cn } from "@/lib/tailwind";
import { handleGetDiscount } from "@/utils/common";
import React from "react";

const SummaryView = ({
  name,
  price,
  listPrice,
  title,
  className,
  keys,
  priceValue,
  listPriceValue,
}: {
  className?: string;
  name: React.ReactNode;
  title: React.ReactNode;
  price?: React.ReactNode;
  listPrice?: React.ReactNode;
  keys: string;
  priceValue?: number;
  listPriceValue?: number;
}) => {
  // Same as PDP: show offer UI when handleGetDiscount(costPrice/list, sale) returns a %
  const discountPercentage =
    keys === "model-price" &&
    listPriceValue != null &&
    priceValue != null &&
    listPriceValue >= 1
      ? handleGetDiscount(listPriceValue, priceValue)
      : "";
  const hasDiscount = Boolean(discountPercentage);

  return (
    <>
      {/* Desktop View */}
      <div className={cn("hidden text-sm sm:flex sm:justify-between", className)}>
        <div>
          <p className="font-semibold">{title}</p>
          <p className="text-tertiary-6">{name}</p>
        </div>
        <div className="flex flex-col">
          {listPrice && hasDiscount && (
            <del className="font-bold text-gray-500">{listPrice}</del>
          )}
          {price && (
            <p className={cn("font-bold", hasDiscount && "text-red-500")}>{price}</p>
          )}
          {/* TODO(QA): When Qatar (qa) is enabled, gate this % with NEXT_PUBLIC_PERCENTAGE_SYMBOL_HIDE_COUNTRIES
              via getPercentHideCountries()/displayPercentage (same as Magrabi LCP LHS summary). */}
          {hasDiscount ? (
            <div className="mt-1 text-sm font-semibold">-{discountPercentage}%</div>
          ) : null}
        </div>
      </div>

      {/* Mobile View */}
      <div className={cn("flex justify-between text-sm sm:hidden px-4", className)}>
        <p className="font-semibold">{title}</p>
        <div className="text-end text-tertiary-6">
          <p className="text-tertiary-6">{name}</p>
          <div className="flex flex-col">
            {listPrice && hasDiscount && (
              <del className="font-bold text-gray-500">{listPrice}</del>
            )}
            {price && (
              <p className={cn("font-bold", hasDiscount && "text-red-500")}>{price}</p>
            )}
            {/* TODO(QA): When Qatar (qa) is enabled, gate this % with NEXT_PUBLIC_PERCENTAGE_SYMBOL_HIDE_COUNTRIES
                via getPercentHideCountries()/displayPercentage (same as Magrabi LCP LHS summary). */}
            {hasDiscount ? (
              <div className="mt-1 text-sm font-semibold">-{discountPercentage}%</div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryView;
